import {
  Directive,
  ElementRef,
  inject,
  OnDestroy,
  output,
  Renderer2,
} from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[clickOutside]',
})
export class ClickOutsideDirective implements OnDestroy {
  private readonly elementRef = inject(ElementRef);
  private readonly renderer = inject(Renderer2);
  private readonly listener: (() => void) | null = null;

  clickOutside = output<void>();

  constructor() {
    this.listener = this.renderer.listen('document', 'click', (e: Event) => {
      if (!this.elementRef.nativeElement.contains(e.target)) {
        this.clickOutside.emit();
      }
    });
  }

  ngOnDestroy(): void {
    this.listener?.();
  }
}
